import { RouterModule } from "@angular/router";
import { LOCALE_ID, NgModule } from "@angular/core";
import { MAT_DATE_LOCALE, DateAdapter } from '@angular/material';
import { PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import { CommonModule, CurrencyPipe, DatePipe } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MaterialModule } from "../material.module";
import { CustomFormlyModule } from "../formly/formly-module";
import { CustomDateAdapter } from "../data-adapter/custom-data-adapter";
import { NgSelectModule } from "@ng-select/ng-select";
import { IConfig, NgxMaskModule } from "ngx-mask";
import { NgxSummernoteModule } from "ngx-summernote";
import { ComumModule } from "../comum/comum.module";
import { IconPickerComponent } from './components/icon-picker/icon-picker.component';
import { NgxExtendedPdfViewerModule } from "ngx-extended-pdf-viewer";
import { AnexoViewerV2Component } from "./components/anexo-viewer-v2/anexo-viewer-v2.component";
import { AnexoUploaderV2Component } from "./components/anexo-uploader-v2/anexo-uploader-v2.component";
import { PipesModule } from "../pipes/pipes.module";
import { DirectivesModule } from "../directives/directives.module";
import { TermosAceitosComponent } from "./components/termos-aceitos/termos-aceitos.component";
import { AnaliseCreditoIntegradorComponent } from "./components/analise-credito-integrador/analise-credito-integrador.component";
import { PopupComponent } from "./components/popup/popup.component";
import {OverlayModule} from '@angular/cdk/overlay';

export let options: Partial<IConfig> | (() => Partial<IConfig>) = {};

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

@NgModule({
  declarations: [
    IconPickerComponent,
    AnexoUploaderV2Component,
    AnexoViewerV2Component,
    TermosAceitosComponent,
    AnaliseCreditoIntegradorComponent,
    PopupComponent,
  ],
  entryComponents: [],
  imports: [
    CommonModule,
    ComumModule,
    CustomFormlyModule,
    FormsModule,
    MaterialModule,
    NgSelectModule,
    NgxMaskModule.forRoot(options),
    ReactiveFormsModule,
    NgxSummernoteModule,
    NgxExtendedPdfViewerModule,
    PipesModule,
    DirectivesModule,
    OverlayModule
  ],
  exports: [
    RouterModule,
    IconPickerComponent,
    AnexoUploaderV2Component,
    AnexoViewerV2Component,
    TermosAceitosComponent,
    AnaliseCreditoIntegradorComponent,
    PopupComponent,
  ],
  providers: [
    { provide: LOCALE_ID, useValue: "pt-BR" },
    { provide: MAT_DATE_LOCALE, useValue: "pt-BR" },
    { provide: DateAdapter, useClass: CustomDateAdapter },
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
    CurrencyPipe,
    DatePipe,
  ],
})
export class CoreSharedModule {}
